import { ApiCreditcardWithSecurityCode } from '@/models/api/creditcard'
import { SubscriptionService } from '@/services/api/subscription'
import {
  CreditcardPaymentProviderServiceForSubscription,
} from '@/services/payment/creditcard-payment-provider/creditcard-payment-provider-service'
import { CreditcardPayment } from '@/services/payment/types'
import {
  SubmitChangePayment,
  SubmitParameter
} from '@spa/components/pages/mypage/subscription/contracted/detail/edit/payment/interaction/submit-change-payment'
import { User } from '@spa/store/modules/user/types'
import { Either, left } from 'fp-ts/lib/Either'

export class SubmitChangeToCreditCard implements SubmitChangePayment {
  constructor(
    private readonly cardPaymentProvider: CreditcardPaymentProviderServiceForSubscription,
    private readonly subscriptionApiServiceViaLegacyProxy: SubscriptionService,
    private readonly creditCard: ApiCreditcardWithSecurityCode,
    private readonly user: User
  ) {
  }

  async submit(id: string, param: SubmitParameter): Promise<Either<Error, null>> {
    const resCreateCreditCardParam = await this.createCreditcardPayment()

    return resCreateCreditCardParam.fold(
      error => Promise.resolve(left(error)),
      (paramsForCreditCard) => {
        const paymentParam =  {
          ...param,
          ...paramsForCreditCard,
        }

        return this.subscriptionApiServiceViaLegacyProxy.edit(
          id,
          {
            payment: JSON.stringify(paymentParam),
          }
        )
      }
    )
  }

  private async createCreditcardPayment(): Promise<Either<Error, CreditcardPayment>> {
    return this.cardPaymentProvider.createPaymentPayload(
      this.creditCard,
      this.user
    )
  }
}
